<template>
  <LoadingSpinner v-if="loading" />
  <Fragment v-else>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('meta.fractions'), name: 'fractions' }, { text: fraction.localized_name }]" />
      </template>
      <template v-slot:meta>
        <button
          v-if="fraction.archived"
          @click="unarchiveFraction"
          class="button button-green button-small button-round"
        >
          {{ $t('fractions.unarchive') }}
        </button>
        <button
          v-else-if="fraction.can_be_deleted"
          @click="deleteFraction"
          class="button button-red button-small button-round"
        >
          {{ $t('fractions.delete') }}
        </button>
        <button
          v-else-if="fraction.can_be_archived"
          @click="archiveFraction"
          class="button button-green button-small button-round"
        >
          {{ $t('fractions.archive') }}
        </button>
        <button
          v-else
          disabled="true"
          :title="$t('fractions.cannotBeDeleted')"
          class="button button-red button-small button-round"
        >
          {{ $t('fractions.delete') }}
        </button>
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <FractionsForm
        @submit="updateFraction"
        :companyUuid="companyUser.company_uuid"
        :fractionUuid="$route.params.fractionUuid"
      />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import BreadCrumbs from '@/components/BreadCrumbs'
import FractionsForm from '@/components/Fractions/FractionsForm.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader/index.vue'
import CompanyNav from '@/components/company_nav.vue'

import fractionsApi from '@/api/companies/fractions'

export default {
  components: {
    BreadCrumbs,
    CompanyNav,
    Fragment,
    FractionsForm,
    LoadingSpinner,
    SectionHeader,
  },
  inject: ['companyUser', 'showPopup'],
  data: () => ({
    fraction: null,
    formData: {
      name: null,
      translations: {},
      avvNumber: null,
      internalId: null,
      color: null,
    },
    loading: true,
  }),
  methods: {
    async updateFraction(formData) {
      const params = {
        uuid: this.$route.params.fractionUuid,
        name: formData.name,
        translations: formData.translations,
        avv_number: formData.avvNumber,
        color: formData.coloring == 'manual' ? formData.color : null,
      }

      if (this.companyUser.company_type == 'industry') {
        params.internal_id = formData.internalId
        params.selectable_in_orders = formData.selectableInOrders
      }

      const response = await fractionsApi.update(this.companyUser.company_uuid, params)

      if (response.success) {
        this.$router.push(`/company/fractions`)
      }
    },
    async unarchiveFraction() {
      const result = await fractionsApi.unarchive(this.companyUser.company_uuid, this.fraction.uuid)
      if (result.success) this.$router.push({ name: 'fractions' })
    },
    async deleteFraction() {
      const confirmAlert = await this.showPopup({ content: this.$t('fractions.deleteConfirmation'), type: 'confirm' })
      if (!confirmAlert) return null

      const result = await fractionsApi.delete(this.companyUser.company_uuid, this.fraction.uuid)
      if (result.success) this.$router.push({ name: 'fractions' })
    },
    async archiveFraction() {
      const confirmAlert = await this.showPopup({
        content: this.$t('fractions.archiveConfirmation'),
        type: 'confirm',
      })
      if (!confirmAlert) return null

      const result = await fractionsApi.archive(this.companyUser.company_uuid, this.fraction.uuid)
      if (result.success) this.$router.push({ name: 'fractions' })
    },
  },
  async created() {
    this.fraction = await fractionsApi.get(this.companyUser.company_uuid, this.$route.params.fractionUuid)
    this.loading = false
  },
}
</script>
